import { GET_AUTH_DATA, IS_TOKEN_ALIVE } from "../mutation-types";
import { tokenAlive } from "../../utils/jwtHelper";

export default {
  [GET_AUTH_DATA]: state => {
    return state;
  },
  [IS_TOKEN_ALIVE]: state => {
    if (!state.expiresIn) return false;
    return tokenAlive(state.expiresIn);
  }
};
